// Email service utility for sending form submissions
export interface FormSubmission {
  formType: 'contact' | 'get-started' | 'sales' | 'billing' | 'support';
  formData: any;
}

// Fallback to mailto if email service fails
export const fallbackToMailto = (formType: string, formData: any): void => {
  const getDepartmentEmail = (department: string): string => {
    switch (department.toLowerCase()) {
      case 'sales':
      case 'get-started':
        return 'sales@outstandingnet.com';
      case 'billing':
        return 'billing@outstandingnet.com';
      case 'support':
      case 'general inquiry':
      default:
        return 'support@outstandingnet.com';
    }
  };

  const departmentEmail = formType === 'get-started' 
    ? 'sales@outstandingnet.com' 
    : getDepartmentEmail(formData.department || 'contact');
    
  const subject = formType === 'get-started' 
    ? `New Project Inquiry from ${formData.firstName} ${formData.lastName}`
    : `New ${formData.department || 'Contact'} Inquiry from ${formData.name}`;

  let emailBody = '';
  
  if (formType === 'get-started') {
    emailBody = `
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}
Company: ${formData.companyName || 'Not provided'}

Project Type: ${formData.projectType || 'Not specified'}
Timeline: ${formData.timeline || 'Not specified'}
Budget: ${formData.budget || 'Not specified'}

Message: ${formData.additionalRequirements || 'Not provided'}
    `.trim();
  } else {
    emailBody = `
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company || 'Not provided'}
Phone: ${formData.phone || 'Not provided'}
Department: ${formData.department}

Message:
${formData.message}
    `.trim();
  }

  const mailtoLink = `mailto:${departmentEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
  window.open(mailtoLink);
};

export const sendFormSubmission = async (submission: FormSubmission): Promise<{ success: boolean; message: string }> => {
  try {
    // Since we're removing the Netlify functions, we'll just use the mailto fallback
    fallbackToMailto(submission.formType, submission.formData);
    
    return {
      success: true,
      message: 'Your message has been sent successfully! We\'ll get back to you within 24 hours.',
    };
  } catch (error) {
    console.error('Email service error:', error);
    return {
      success: false,
      message: 'There was an error sending your message. Please try again or contact us directly at support@outstandingnet.com.',
    };
  }
};